import React, { useState } from 'react'
import { router, usePage, Link } from '@inertiajs/react'
import {
  Box, Button, Paper, TextField, MenuItem, Stack, Typography,
} from '@mui/material'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

export default function Form({ invitation = {}, roles = [], errors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/settings/invitations`

  const [email, setEmail] = useState(invitation.email || '')
  const [role, setRole] = useState(invitation.role || 'manager')
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitting(true)
    router.post(basePath, { user_invitation: { email, role } }, {
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <Box>
      <PageHeader
        title="Neue Einladung"
        breadcrumbs={[
          { label: 'Dashboard', href: `/m/${tenant.slug}` },
          { label: 'Einstellungen' },
          { label: 'Einladungen', href: basePath },
          { label: 'Neu' },
        ]}
      />

      <Paper variant="outlined" sx={{ p: 3, maxWidth: 560 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="E-Mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
              error={Boolean(errors.email)}
              helperText={errors.email?.[0]}
              slotProps={{ htmlInput: { 'data-testid': 'invitation-email-input' } }}
            />
            <TextField
              select
              label="Rolle"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
              fullWidth
              error={Boolean(errors.role)}
              helperText={errors.role?.[0]}
              slotProps={{ htmlInput: { 'data-testid': 'invitation-role-input' } }}
            >
              {roles.map((r) => (
                <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
              ))}
            </TextField>

            {errors.base && (
              <Typography color="error" variant="body2">{errors.base.join(', ')}</Typography>
            )}

            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button component={Link} href={basePath}>Abbrechen</Button>
              <Button
                type="submit"
                variant="contained"
                disabled={submitting}
                data-testid="invitation-submit-btn"
              >
                Einladung senden
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Paper>
    </Box>
  )
}
